import { useMemo } from 'react';
import {
  AgxBodyText,
  AgxColumn,
  AgxDivider,
  AgxHeader,
} from '@urbanx/agx-ui-components';
import NoDataImg from 'assets/images/Curiosity.svg?react';
import SidebarLeaderboardRowLoader from './SidebarLeaderboardRowLoader';
import SidebarLeaderboardRow from './SidebarLeaderboardRow';
import { LeaderboardRankings } from 'Api/Rex/Types/types';

interface SidebarLeaderboardProps {
  loading: boolean;
  leaderboardStats?: LeaderboardRankings | null;
  boardName: string;
}

const SidebarLeaderboard = ({
  loading,
  leaderboardStats,
  boardName,
}: SidebarLeaderboardProps) => {
  const getMonthName = () =>
    new Date().toLocaleString('default', { month: 'long' });

  const panelHeaderText = useMemo(() => {
    return `Top ${boardName} - ${getMonthName()}`;
  }, [boardName]);

  const noData = !loading && !leaderboardStats;

  const { entityRankings } = leaderboardStats || {};

  return (
    <AgxColumn extraClasses="reportSidebarLeaderboard">
      <AgxHeader size={5} extraClasses="header-text">
        {!loading && panelHeaderText}
      </AgxHeader>
      <div className="sidebarLeaderboardGrid">
        {noData && (
          <>
            <AgxDivider />
            <AgxColumn fill centered extraLargeGap extraClasses="noDataDiv">
              <NoDataImg />
              <AgxColumn>
                <AgxHeader size={3} centered>
                  No sales have been recorded yet
                </AgxHeader>
                <AgxBodyText medium centered>
                  Check back in a bit!
                </AgxBodyText>
              </AgxColumn>
            </AgxColumn>
          </>
        )}
        {loading &&
          [...Array(5)].map((i, idx) => (
            <SidebarLeaderboardRowLoader key={idx} />
          ))}
        {!loading &&
          entityRankings?.map((entityRanking, idx) => (
            <SidebarLeaderboardRow
              key={`row-${idx}`}
              leaderboardPosition={entityRanking}
              addRingToImage={true}
            />
          ))}
      </div>
    </AgxColumn>
  );
};

export default SidebarLeaderboard;
